import './../node_modules/bulma/css/bulma.css';
import Vue from 'vue'
import App from './App.vue'
import VueGtm from 'vue-gtm';
import router from "./router";
//import VueAnalytics from 'vue-analytics';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faFacebook);
library.add(faPhone);
library.add(faEnvelope);

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueGtm, {
  id: 'GTM-T9BP9GVK', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)

});

/*
Vue.use(VueAnalytics, {
  id: 'UA-117114777-2',
  router
});

 */


Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
